"use client";
import React, { useEffect, useRef } from "react";
import { AddressProps } from ".";
import Image from "next/image";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Location = ({ data }: AddressProps) => {
  const iconRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (data && iconRef.current) {
      const addressImg = iconRef.current.querySelectorAll(".addressImg");

      const tl = gsap.timeline({ defaults: { ease: "power3.inOut" } });

      {addressImg.length && tl.fromTo(
        addressImg,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.7,
          ease: "slow(0.4, 0.4, false)",
          stagger: 0.2,
        }
      );}

      ScrollTrigger.create({
        trigger: iconRef.current,
        start: "top 60%",
        end: "bottom 10%",
        animation: tl,

        onEnter: () => tl.play(),
        onLeaveBack: () => tl.reverse(),
        // markers: true
      });
    }
  }, [data]);
  return (
    <div
      ref={iconRef}
      className="container flex flex-col items-center mx-auto section-spacing"
    >
      <h1 className="text-[#032d60] font-semibold mb-5 sm:mb-10 text-center text-2xl sm:text-3xl lg:text-4xl">
        {data.headingAddress}
      </h1>
      <div className="flex flex-col items-center justify-center px-4 mx-auto sm:flex-row lg:px-0 lg:w-full gap-y-8">
        {data.addresses.map((location: any, index: number) => {
          const imgurl = location?.icon?.data?.attributes?.url;
          return (
            <div key={index} className="flex addressImg ">
              <div className="flex items-start justify-center ">
                <Image
                  src={imgurl || ""}
                  alt={location?.icon?.data.attributes.name || "icon"}
                  width={52}
                  height={52}
                />
              </div>
              <div className="flex flex-col flex-1 mx-4 ">
                <h3 className="font-bold text-medium text-[#032d60]">
                  {location.title}
                </h3>
                <p className="mt-3 text-[#032d60] font-sm text-medium ">
                  {location.descriptionAddress}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Location;
